/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * A service that must be extended in case you want to rewrite the default
 * uploading process. In case you have a Regular License, you'll get a simple upload
 * service, for any other paid Licenses - you get an Image Gallery.
 *
 * It won't work if you have a Regular/Free License - you'll get an error on running the project,
 * you need either an [Extended or Commercial License]{@link https://wlocalhost.org} key for this purpose.
 *
 * @example
 * // Create a custom service
 * class YourOwnUploaderService extends IpUserImageUploaderService {}
 *
 * // Rewrite it into AppModule
 * { provide: IpUserImageUploaderService, useClass: YourOwnUploaderService }
 */
@Injectable()
export abstract class IpUserImageUploaderService {
  /**
   * A method called once end user intends to upload an image.
   * It must returns always an `Observable<string>` - where `string` is the uploaded
   * image path.
   *
   * @return Uploaded image path.
   */
  abstract browse$(): Observable<string>;
}
